export enum DriverEventType {
  Sick = 0,
  HomeTime = 1,
  PTO = 2,
  TimeOff = 3,
  TemplateTimeOff = 4,
  HosReset34h = 5,
}

export enum DriverEventChangeReason {
  DriverRequested = 0,
  Maintenance = 1,
  Other = 2,
}

export interface DriverEventViewModel {
  id: string;
  dateCreatedUtc?: Date;
  start: Date;
  end: Date;
  eventType: DriverEventType;
  notes?: string;
  driverId: string;
  changeCount?: number;
  datesChanged?: boolean;
  uploadBatchId?: string;
}

export interface DriverEventChangeViewModel {
  id: string;
  driverEventId: string;
  previousStart: Date;
  previousEnd: Date;
  newStart: Date;
  newEnd: Date;
  reason: DriverEventChangeReason;
  reasonNote?: string;
  dateCreatedUtc: Date;
  changedByUserId: string;
}

export class DriverEventTypeHelper {
  static toString(type: DriverEventType): string {
    switch (type) {
      case DriverEventType.Sick:
        return "Sick";
      case DriverEventType.HomeTime:
        return "Home Time";
      case DriverEventType.PTO:
        return "PTO";
      case DriverEventType.TimeOff:
        return "Time Off";
      case DriverEventType.TemplateTimeOff:
        return "Time Off";
      case DriverEventType.HosReset34h:
        return "34h Reset";
      default:
        return "";
    }
  }

  static fromString(str: string): DriverEventType {
    switch (str) {
      case "Sick":
        return DriverEventType.Sick;
      case "Home Time":
        return DriverEventType.HomeTime;
      case "PTO":
        return DriverEventType.PTO;
      case "Time Off":
        return DriverEventType.TimeOff;
      case "Tmpl. Time Off":
        return DriverEventType.TemplateTimeOff;
      default:
        return DriverEventType.TimeOff;
    }
  }
}

export class DriverEventChangeReasonHelper {
  static toString(reason: DriverEventChangeReason): string {
    switch (reason) {
      case DriverEventChangeReason.DriverRequested:
        return "Driver Requested";
      case DriverEventChangeReason.Maintenance:
        return "Maintenance";
      case DriverEventChangeReason.Other:
        return "Other";
      default:
        return "";
    }
  }

  static fromString(str: string): DriverEventChangeReason {
    switch (str) {
      case "Driver Requested":
        return DriverEventChangeReason.DriverRequested;
      case "Maintenance":
        return DriverEventChangeReason.Maintenance;
      case "Other":
        return DriverEventChangeReason.Other;
      default:
        return DriverEventChangeReason.Other;
    }
  }

  static getOptions(): { label: string; value: DriverEventChangeReason }[] {
    return [
      { label: "Driver Requested", value: DriverEventChangeReason.DriverRequested },
      { label: "Maintenance", value: DriverEventChangeReason.Maintenance },
      { label: "Other", value: DriverEventChangeReason.Other },
    ];
  }
}
